export default {
  common: {
    backToHome: 'Back to Home',
    back: 'Back',
    pageNotFound: 'Page Not Found',
    pageForbidden: 'Access Forbidden',
    edit: 'Edit',
    actions: 'Actions',
    active: 'Active',
    inactive: 'Inactive',
    save: 'Save',
    cancel: 'Cancel',
  },
  tip: {
    pageNotFound: 'The page you are looking for does not exist or has been moved.',
    pageForbidden: 'You do not have permission to access this page.'
  },
  sidebar: {
    command: {
      search: 'Search…',
    },
  },
}
